module.exports = __webpack_public_path__ + "img/IT0004599255415.d1b6ddb1.png";